// 1:1 grid tile with label below — the "AI Edits" pattern from the Mody reference.
// Use inside a 3-column grid: <div className="grid grid-cols-3 gap-3">{...}</div>
import { cn } from "@/lib/utils";
import { ImageWithSkeleton } from "@/components/ui/image-with-skeleton";

interface EditCardProps {
  image: string;
  label: string;
  onClick?: () => void;
  selected?: boolean;
  badge?: React.ReactNode;
  className?: string;
}

export const EditCard = ({ image, label, onClick, selected, badge, className }: EditCardProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn("group flex flex-col gap-1.5 text-left active:scale-[0.97] transition-transform", className)}
    >
      <div
        className={cn(
          "relative aspect-square overflow-hidden rounded-2xl bg-muted ring-1 ring-white/10 transition-all",
          selected && "ring-2 ring-primary shadow-[0_0_24px_-4px_hsl(var(--primary))]",
        )}
      >
        <ImageWithSkeleton
          src={image}
          alt={label}
          imageClassName="transition-transform duration-300 group-active:scale-105"
        />
        {badge && (
          <div className="absolute left-1.5 top-1.5 rounded-full bg-black/70 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wider text-white backdrop-blur-md">
            {badge}
          </div>
        )}
      </div>
      <span className="px-0.5 text-center text-[11px] font-medium leading-tight text-foreground/90 line-clamp-2">
        {label}
      </span>
    </button>
  );
};
